<template>
  <base-dialog class="sync-data-dialog" width="485px" :visible.sync="visible">
    <template v-slot:header>
      批量同步
    </template>
    <div class="option-rule">
      <span class="tab">选择规则</span>
      <el-select v-model="ruleId" placeholder="">
        <el-option-group v-for="group in ruleGroup" :key="group.label" :label="group.label">
          <el-option
            v-for="item in group.options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-option-group>
      </el-select>
    </div>
    <div class="option-company" v-if="companyVisible">
      <span class="tab">选择企业</span>
      <select-scope
        title="选择企业"
        multiple
        :show-user-tab="false"
        :show-department-tab="false"
        v-model="companyValue"
        :additional-tabs="additionalTabs"
        :var-group="canUseVars"
      ></select-scope>
    </div>
    <template v-slot:footer>
      <base-button @click="visible = false">取消</base-button>
      <base-button type="primary" @click="submit">确认</base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/UIComponents/BaseDialog"
import BaseButton from "@/components/UIComponents/Button"
import { getCompanyConnectList, getCompanyConnectType, getOutSyncRuleList } from "@/api/connect"
import { syncData } from "@/api/sync"
import { getAvailableSheets, getSheet } from "@/api/sheet/sheet"
import SelectScope from "@/components/UIComponents/SelectScope"
import { decorateSheet } from "@/utils/sheet"

export default {
  name: "SyncDataDialog",
  components: {
    BaseDialog,
    BaseButton,
    SelectScope
  },
  data() {
    return {
      visible: false,
      ruleId: "",
      companyValue: [],
      ruleGroup: [],
      connectedCompanies: [],
      connectedTypes: [],
      ruleList: [],
      curSheet: {}
    }
  },
  props: {
    selection: Object,
    viewId: String,
    sheetId: String,
    filters: Array,
    appId: String,
    pageInfo: Object
  },
  computed: {
    ruleMap() {
      return this._.keyBy(this.ruleList, "id")
    },
    companyVisible() {
      return this.ruleMap[this.ruleId]?.master
    },
    additionalTabs() {
      return [
        {
          label: "企业",
          value: "company",
          options: this.connectedCompanies.map(({ targetId, targetName }) => ({
            id: targetId,
            name: targetName
          }))
        },
        {
          label: "企业角色",
          value: "companyRole",
          options: this.connectedTypes.map(({ id, name }) => ({ id, name }))
        }
      ]
    },
    availableSheetMap() {
      return this.availableSheets.reduce((acc, cur) => {
        if (cur.sheets?.length) cur.sheets.forEach(sheet => (acc[sheet.sheetId] = sheet))
        return acc
      }, {})
    },
    canUseVars() {
      let varGroup = [this.getVars(this.curSheet, ["company"])]
      decorateSheet(this.curSheet)
        .controls.filter(control => control._type === "ref" && control.oneFlag && control._cid)
        .forEach(refControl => {
          if (this.availableSheetMap[refControl.refSheetId])
            varGroup.push(
              this.getVars(this.availableSheetMap[refControl.refSheetId], ["company"], refControl)
            )
        })
      return varGroup.filter(i => i.options.length != 0)
    }
  },
  methods: {
    open() {
      this.ruleId = ""
      this.companyValue = []
      getOutSyncRuleList(this.appId).then(ruleList => {
        this.ruleGroup = []
        this.ruleList = ruleList
        let masterRules = [],
          slaveRules = []
        ruleList
          .filter(rule => rule.sheetId == this.sheetId)
          .forEach(rule => {
            if (rule.master) masterRules.push(rule)
            else slaveRules.push(rule)
          })
        if (masterRules.length > 0) {
          this.ruleGroup.push({
            label: "主规则",
            options: masterRules
          })
        }
        if (slaveRules.length > 0) {
          this.ruleGroup.push({
            label: "从规则",
            options: slaveRules
          })
        }
      })
      getCompanyConnectList({ passive: false }).then(companies => {
        this.connectedCompanies = companies
      })
      getCompanyConnectType({ withNum: false }).then(types => (this.connectedTypes = types))
      getSheet(this.sheetId).then(res => (this.curSheet = res))
      getAvailableSheets({ appId: this.appId }).then(availableSheets => {
        this.availableSheets = availableSheets
      })
      this.visible = true
    },
    submit() {
      let dataIds = []
      if (this.selection.command === "本页") {
        this.selection.tableData.forEach(x => {
          dataIds.push(x.id)
        })
      }
      syncData({
        master: Boolean(this.ruleMap[this.ruleId]?.master),
        ruleId: this.ruleId,
        searchParam: {
          dataIds: this.selection.command === "本页" ? dataIds : null,
          filtersList: this.selection.command === "本页" ? [] : this.filters,
          sheetId: this.sheetId,
          viewId: this.viewId,
          page: this.pageInfo?.page,
          size: this.pageInfo?.size
        },
        targetCompanyIds: this.companyValue
      }).then(() => {
        this.$message.success("同步已提交，请在同步记录查看同步结果")
        this.$emit("dealLast")
        this.visible = false
      })
    },
    syncEvent() {
      return syncData({
        master: Boolean(this.ruleMap[this.ruleId]?.master),
        ruleId: this.ruleId,
        searchParam: {
          dataIds: null,
          filtersList: this.filters,
          sheetId: this.sheetId,
          viewId: this.viewId,
          page: this.pageInfo.page,
          size: this.pageInfo.size
        },
        targetCompanyIds: this.companyValue
      }).then(() => {
        this.$message.success("同步已提交，请在同步记录查看同步结果")
        this.$emit("dealLast")
      })
    },
    getVars(sheetDef, canUseType, refControl) {
      let vars = [],
        title = ""
      if (!refControl) title = sheetDef.name
      else title = refControl.name
      decorateSheet(sheetDef).controls.forEach(control => {
        if (canUseType.includes(control._type)) {
          let v = control._cid
          let name = control.name
          if (refControl) v = refControl._cid + "_" + v
          vars.push({
            label: `[${title}] ${name}`,
            type: control._type,
            value: "v" + v
          })
        }
      })
      return { title, label: title, options: vars }
    }
  }
}
</script>

<style lang="scss" scoped>
.sync-data-dialog {
  .option-company {
    margin-top: 10px;
  }
  .tab {
    margin-right: 15px;
  }
  .el-select,
  .select-scope {
    display: inline-block;
    width: 360px;
  }
}
</style>
